module.exports = __webpack_public_path__ + "img/boat1.0814d923.png";